import { Component, Vue, Ref, Prop } from "vue-property-decorator";
import './alarm.less'
import { AlarmStatisticsServiceProxy, AlarmDetailDTO, AlarmStatisticsDTO,AlarmDetailDTOStatisticalMethod } from '@/service-proxies/app-v2/mdc.service-proxies'
import dayjs from 'dayjs';
const assp = new AlarmStatisticsServiceProxy()

@Component({
  components: {
  }
})
export default class AlarmBody extends Vue {
  @Prop({ default: false }) visible: Boolean
  @Prop({ default: () => ([]) }) data: Array<any>
  @Prop({ default: 0 }) istotalAdd: Number
  @Prop({ default: true }) viewMore: Boolean
  currt = 1
  get tableColumns() {
    return [{
      title: this.$t('page_alarm_alarmcode'),
      dataIndex: 'alarmCode',
      key: 'alarmCode'
    },{
      title: this.$t('page_alarm_alarmmsg'),
      dataIndex: 'alarmMsg',
      key: 'alarmMsg',
      ellipsis: true
    },{
      title: this.$t('page_alarm_alarmtime'),
      dataIndex: 'alarmTime',
      key: 'alarmTime',
      customRender: (_value) => {
        return dayjs(_value).format('YYYY-MM-DD HH:mm:ss')
      }
    }]
  }

  pageIndexChange(){
    if(this.istotalAdd == 1){
      this.currt = 1
    } else {
      this.currt += 1
    }
    this.$emit('change', this.currt)
  }

  render() {
    return (
      <a-modal
        title={this.$t('page_alarm_detail')}
        visible={this.visible}
        onOk={() => this.$emit('close')}
        onCancel={() => this.$emit('close')}
        width={600}
        maskClosable={false}
      >
        <div style="max-height: 500px; overflow: auto">
          <ml-table
            columns={this.tableColumns}
            data-source={this.data}
          >
          </ml-table>
          { this.viewMore ? 
          <a-button style="width: 100%; margin-top: 8px;" type="default" onClick={this.pageIndexChange}>
            {this.$t('page_mdc_alarm_view_more')}
          </a-button> : null }
        </div>
      </a-modal>
    )
  }
}